import { ContentInformationItem } from '@app/api/models/ContentInformation/ContentInformationModels';
import ContentInformationApi from '@app/api/public/ContentInformationApi';
import { useMutation, useQueryClient } from 'react-query';
import { memberInformationQueryKeys } from './memberInformationQueries';

type Variables = { id: ContentInformationItem['id'] };

const useRemoveInformation = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return ContentInformationApi.remove(varables.id);
        },
        {
            onSettled: () => {
                client.invalidateQueries(memberInformationQueryKeys.all);
            },
        }
    );
};

export default useRemoveInformation;
